export default __webpack_public_path__ + "static/media/etaseco.3feeca73.png";